import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";

import AuthProviderWithHistory from "./auth/AuthProviderWithHistory";
import App from "./App";

// using css file from bootstrap 4.5.2 as newer version was causing layout issue
import "./bootstrap.min.css";
import "./index.css";

ReactDOM.render(
  <Router>
    <AuthProviderWithHistory>
      <App />
    </AuthProviderWithHistory>
  </Router>,

  document.getElementById("root")
);
